<template>
  <div v-if="inputValues">
    <vs-prompt
      id="dialog-offing-wave-point-input"
      @accept="addOffingWavePoint"
      @cancel="cancel"
      @close="close"
      :color="color"
      :active.sync="isShow"
      :title="title"
      :accept-text="acceptText"
      :cancel-text="cancelText"
      :is-valid="validateInput"
    >
      <div id="dialog-offing-wave-point-input-form">
        <vs-row vs-w="12" class="mt-6 mb-6">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="4">
            <span class="input-label">ポイント名</span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="8">
            <vs-input v-model="inputValues.pointName"
                      :danger="validateInputPointName"
                      :danger-text="getInputPointNameError()"
            />
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" class="mt-6 mb-6">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="4">
            <span class="input-label">緯度</span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="8">
            <vs-input v-model="inputValues.lat"
                      :danger="validateInputLat"
                      :danger-text="getInputLatError()"/>
          </vs-col>
        </vs-row>

        <vs-row vs-w="12" class="mt-6 mb-6">
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="4" vs-sm="4" vs-xs="4">
            <span class="input-label">経度</span>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-lg="8" vs-sm="8" vs-xs="8">
            <vs-input v-model="inputValues.lng"
                      :danger="validateInputLng"
                      :danger-text="getInputLngError()"/>
          </vs-col>
        </vs-row>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import FireStoreService from "@/services/fireStoreService";
import _ from 'lodash'

// Store
const {
  mapActions: mapActionsOfLiveMap,
  mapState: mapStateOfLiveMap,
  mapGetters: mapGettersOfLiveMap,
  mapMutations: mapMutationsOfLiveMap
} = createNamespacedHelpers("liveMap");

export default {
  props: {},
  data() {
    return {
      showDialog: false,
      title: "沖波ポイント予測設定",
      acceptText: "保存",
      cancelText: "キャンセル",
      localDialogOffingWavePointInputForm: null,
      isShow: false,
      inputValues: null,
      oldInputValues: null,
      color: "#2D9CDB"
    };
  },
  watch: {
    dialogOffingWavePointInputForm(value) {
      if (value.isShow) {
        this.isShow = _.cloneDeep(value.isShow)
        this.inputValues = _.cloneDeep(value.inputValues)
      }
      if (value.oldInputValues) {
        this.oldInputValues = _.cloneDeep(value.oldInputValues)
      }
    }
  },
  computed: {
    ...mapStateOfLiveMap({
      dialogOffingWavePointInputForm: state => state.dialogOffingWavePointInputForm,
      offingWavePoints: state => state.offingWavePoints,
    }),
    ...mapGettersOfLiveMap(["getOffingWavePointNextId"]),
    validateInputPointName() {
      return this._validateInputPointName()
    },
    validateInputLat() {
      return this._validateInputLat()
    },
    validateInputLng() {
      return this._validateInputLng()
    },
    validateInput() {
      return !this._validateInputPointName() && !this._validateInputLat() && !this._validateInputLng()
    }
  },
  methods: {
    ...mapActionsOfLiveMap([
      "getOffingWavePointInfo",
    ]),
    ...mapMutationsOfLiveMap([
      "ADD_OFFING_WAVE_POINT",
      "SET_DIALOG_OFFING_WAVE_POINT_INPUT_FORM",
      "UPDATE_OFFING_WAVE_POINT"
    ]),
    async addOffingWavePoint() {
      let payload = {
        pointId: this.getOffingWavePointNextId,
        pointName: this.inputValues.pointName,
        coordinate: [this.inputValues.lng, this.inputValues.lat],
        isRequestLatestForecast: true
      }
      let point = await this.getOffingWavePointInfo(payload)
      this.ADD_OFFING_WAVE_POINT(point)
      await FireStoreService.saveOffingWavePoints(this.offingWavePoints);
      this.SET_DIALOG_OFFING_WAVE_POINT_INPUT_FORM({
        isShow: false,
        values: null
      })
    },
    _validateInputPointName() {
      return this.inputValues.pointName === "" || this.inputValues.pointName.length > 20
    },
    getInputPointNameError() {
      if (this.inputValues.pointName === "") {
        return "ポイント名は必須です"
      }
      if (this.inputValues.pointName.length > 20) {
        return "20文字以内で入力してください"
      }
    },
    _validateInputLat() {
      return this.inputValues.lat === "" || !(this.inputValues.lat < 90 && this.inputValues.lat > -90)
    },
    getInputLatError() {
      if (this.inputValues.lat === "") {
        return "緯度は必須です"
      }
      return "「-90 ~ 90」の範囲で入力してください"
    },
    _validateInputLng() {
      return this.inputValues.lng === "" || !(this.inputValues.lng < 180 && this.inputValues.lng > -180)
    },
    getInputLngError() {
      if (this.inputValues.lng === "") {
        return "経度は必須です"
      }
      return "「-180 ~ 180」の範囲で入力してください"
    },
    close() {
      this._cancel()
    },
    cancel() {
      this._cancel()
    },
    _cancel() {
      this.SET_DIALOG_OFFING_WAVE_POINT_INPUT_FORM({
        isShow: false,
        values: null
      })
      if (this.oldInputValues) {
        this.UPDATE_OFFING_WAVE_POINT(this.oldInputValues)
      }
      this.oldInputValues = null
    },
  }
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#dialog-offing-wave-point-input {

  @media screen and (max-width: $min-width-iphone-8) {
    .vs-dialog {
      width: 250px !important;
    }
  }

}

#dialog-offing-wave-point-input-form {

  .input-label {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    color: #757575;
  }

  .vs-input {
    width: 100%;
  }
}
</style>
